import React, { useContext, useState } from "react";
import styled from "styled-components";
import {
  useTheme,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import Spinner from "../ui/Spinner";
import { Button } from "../ui/forms/Button";
import { OrderSummaryList } from "../Ordering/OrderSummaryList";
import { InvalidOrders } from "../Ordering/InvalidOrders";
import { OrderContext } from "../../contexts/OrderContext";
import { UserContext } from "../../contexts/UserContext";
import Axios from "axios";
import { DatabaseContext } from "../../contexts/DatabaseContext";
import { useSnackbar } from "notistack";
import DoneIcon from "@material-ui/icons/Done";

const OrderSummary = () => {
  const [orderPlaced, setOrderPlaced] = useState(false);
  const [validOrders, setValidOrders] = useState([]);
  const [invalidOrders, setInvalidOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const { orders, removePatronFromOrder, clearOrders, sendOrder } =
    useContext(OrderContext);
  const { enqueueSnackbar } = useSnackbar();
  const { palette } = useTheme();
  const { Site } = useContext(UserContext);
  const { photoRequired, siteType } = Site;
  const { apiUrl } = useContext(DatabaseContext);
  const [DisplayCampaign, setDisplayCampaign] = useState(false);
  const [Img, setImg] = useState("");
  const [CamID, setCamID] = useState("");

  const patronLabel = siteType === 0 || siteType === 5 ? "student" : "patron";

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const { validOrders, invalidOrders } = await sendOrder(orders, {
        photoRequired,
      });
      setOrderPlaced(true);
      setValidOrders(validOrders);
      setInvalidOrders(invalidOrders);
      if (invalidOrders.length == 0) {
        const SCam = await Axios.get(
          `${apiUrl}/api/campaigns/showcampaign/?siteCode=${
            Site.siteCode
          }&userEmail=${localStorage.getItem("email")}`,
        );

        var ci = SCam.data.data;

        if (ci.success == "true") {
          setDisplayCampaign(true);
          setImg(ci.ImagePath);
          setCamID(ci.campaignID);
        } else {
        }
      }
    } catch (err) {
      setValidOrders([]);
      setInvalidOrders([]);
    }
    setLoading(false);
  };

  const reset = () => {
    setOrderPlaced(false);
    clearOrders();
    setValidOrders([]);
    setInvalidOrders([]);
  };

  const CampaignYes = async () => {
    setDisplayCampaign(false);
    const yes = await Axios.put(
      `${apiUrl}/api/campaigns/campaignresults/?siteCode=${
        Site.siteCode
      }&userEmail=${localStorage.getItem("email")}&result=1&CamID=${CamID}`,
    );

    if (yes.success) {
      enqueueSnackbar("Monitor WA will contact you", { variant: "success" });
    }
  };

  const CampaignNo = async () => {
    setDisplayCampaign(false);
    const No = await Axios.put(
      `${apiUrl}/api/campaigns/campaignresults/?siteCode=${
        Site.siteCode
      }&userEmail=${localStorage.getItem("email")}&result=2&CamID=${CamID}`,
    );
  };

  const CampaignLater = async () => {
    setDisplayCampaign(false);
    const Later = await Axios.put(
      `${apiUrl}/api/campaigns/campaignresults/?siteCode=${
        Site.siteCode
      }&userEmail=${localStorage.getItem("email")}&result=3&CamID=${CamID}`,
    );
  };

  const CampaignNever = async () => {
    setDisplayCampaign(false);
    const Never = await Axios.put(
      `${apiUrl}/api/campaigns/campaignresults/?siteCode=${
        Site.siteCode
      }&userEmail=${localStorage.getItem("email")}&result=4&CamID=${CamID}`,
    );
  };

  return loading > 0 ? (
    <SpinContainer>
      <Spinner size="5rem" colour="success" />
    </SpinContainer>
  ) : orderPlaced ? (
    <>
      {validOrders.length > 0 && (
        <ValidOrders>{`${validOrders.length} order${
          validOrders.length !== 1 ? "s" : ""
        } placed`}</ValidOrders>
      )}
      {invalidOrders.length > 0 && (
        <Message colour={palette.error.main} padding="2rem">
          {`The following ${
            invalidOrders.length !== 1 ? invalidOrders.length : ""
          } order${invalidOrders.length !== 1 ? "s" : ""} had ${
            invalidOrders.length !== 1 ? "errors" : "an error"
          }`}
        </Message>
      )}
      <ListContainer>
        <InvalidOrders orders={invalidOrders} colour={palette.error.main} />
      </ListContainer>
      <Actions colour={palette.success.main} background={palette.success.dark}>
        <Button onClick={reset} colour="success" variant="contained">
          Okay
        </Button>
      </Actions>
      <div>
        <Dialog
          maxWidth
          open={DisplayCampaign}
          onClose={() => setDisplayCampaign(false)}
        >
          <DialogContent style={{ width: "900px", height: "500px" }}>
            <PatronPhoto image={Img} />
          </DialogContent>
          <DialogActions>
            <Button
              style={{ color: "white", backgroundColor: "#88CA5E" }}
              onClick={CampaignYes}
            >
              Yes
              <DoneIcon />
            </Button>
            <Button onClick={CampaignNo}>No, Thanks</Button>
            <Button onClick={CampaignLater}>Remind me Later</Button>
            <Button onClick={CampaignNever}>Never send me campaigns</Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  ) : orders.length > 0 ? (
    <>
      <Message padding="2rem">{`The following ${orders.length} ${patronLabel}${
        orders.length > 1 ? "s are" : " is"
      } queued to order`}</Message>
      <ListContainer>
        <OrderSummaryList
          orders={orders}
          remove={removePatronFromOrder}
          colour={palette.success.main}
        />
      </ListContainer>
      <Actions colour={palette.success.main} background={palette.success.dark}>
        <Button colour="success" onClick={clearOrders} margin="0 1rem 0 0">
          Clear
        </Button>
        <Button colour="success" variant="contained" onClick={handleSubmit}>
          Submit Order
        </Button>
      </Actions>
    </>
  ) : (
    <NoOrders>No orders added.</NoOrders>
  );
};

const PatronPhoto = styled.div`
  background-image: ${(props) => `url(${props.image})`};
  background-size: cover;
  width: 100%;
  border-radius: 1rem;
  border: 1px solid;
  height: 100%;
  cursor: pointer;
`;

const ListContainer = styled.div`
  flex: 1;
`;

const Actions = styled.div`
  width: 100%;
  padding: 2rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background: ${(props) => props.background};
  border-radius: 0 0 1.4rem 1.4rem;
  border-top: 1px solid ${(props) => props.colour};
`;

const ValidOrders = styled.p`
  padding: 2rem 2rem 0 2rem;
  font-weight: 700;
  text-transform: uppercase;
`;

const Message = styled.h4`
  color: ${(props) => props.colour};
  padding: ${(props) => props.padding};
`;

const SpinContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const NoOrders = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 4rem;
`;

export default OrderSummary;
